export default __webpack_public_path__ + "static/media/PledgXeCQS.716281a0.svg";